import { render, staticRenderFns } from "./HomeTour.vue?vue&type=template&id=d580328a&scoped=true&v-slot=scope&"
import script from "./HomeTour.vue?vue&type=script&lang=js&"
export * from "./HomeTour.vue?vue&type=script&lang=js&"
import style0 from "./HomeTour.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HomeTour.vue?vue&type=style&index=1&id=d580328a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d580328a",
  null
  
)

export default component.exports